exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".provider-panel--2coSKXelMAeB3DMcszkckW {\n  font-weight: 500;\n}\n", ""]);

// exports
exports.locals = {
	"remainingCapacity": "provider-panel--2coSKXelMAeB3DMcszkckW",
	"remainingCapacity": "provider-panel--2coSKXelMAeB3DMcszkckW"
};